module.exports = __webpack_public_path__ + "media/application/images/icons/picker-shape-13814f98203caab66e1d4795b7858237.svg";